import React from 'react'
import { Checkbox, FormControlLabel, FormGroup, List, ListItem } from '@mui/material'
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded'
import { textColors } from '../Color/Color'
import { fontSizes } from '../Typography/TypographyStyles'

// Define types for filter items and sub-items
interface FilterSubItem {
  id: string
  value: string
  label: string
}

interface FilterItem {
  id: string
  name: string
  filterSubItem: FilterSubItem[]
}

// Define prop types for the component
interface FilterPopoverProps {
  filterItems: FilterItem[]
  selectedFilters: Record<string, string[]>
  onFilterChange: (filterName: string, value: string, checked: boolean) => void
  onSelectAllChange: (filterName: string, checked: boolean) => void
}

const FilterPopover: React.FC<FilterPopoverProps> = ({
  filterItems,
  selectedFilters,
  onFilterChange,
  onSelectAllChange,
}) => {
  return (
    <React.Fragment>
      <List dense={true}>
        {filterItems.map((filter) => (
          <ListItem key={filter.name} divider>
            <FormGroup>
              <FormControlLabel
                sx={{
                  fontWeight: 700,
                  '& .MuiTypography-root': {
                    fontWeight: 700,
                  },
                  margin: 0,
                  padding: 0,
                }}
                control={
                  <Checkbox
                    id={filter.id}
                    checked={selectedFilters[filter.name]?.length === filter.filterSubItem.length}
                    indeterminate={
                      selectedFilters[filter.name]?.length > 0 &&
                      selectedFilters[filter.name]?.length < filter.filterSubItem.length
                    }
                    onChange={(e) => onSelectAllChange(filter.name, e.target.checked)}
                    sx={{
                      color: textColors.purpleTelus,
                      '&.Mui-checked': {
                        color: textColors.purpleTelus,
                      },
                    }}
                    indeterminateIcon={
                      <IndeterminateCheckBoxRoundedIcon
                        sx={{
                          color: textColors.purpleTelus,
                        }}
                      />
                    }
                  />
                }
                label={filter.name.toUpperCase()}
              />
              {filter.filterSubItem.map((subItem) => (
                <FormControlLabel
                  sx={{
                    marginLeft: 2,
                    fontSize: fontSizes.size14,
                    marginTop: 0,
                    padding: 0,
                  }}
                  key={subItem.value}
                  control={
                    <Checkbox
                      id={subItem.id}
                      checked={selectedFilters[filter.name]?.includes(subItem.value)}
                      onChange={(e) => onFilterChange(filter.name, subItem.value, e.target.checked)}
                      sx={{
                        color: textColors.purpleTelus,
                        '&.Mui-checked': {
                          color: textColors.purpleTelus,
                        },
                        paddingY: 0.5,
                      }}
                    />
                  }
                  label={subItem.label}
                />
              ))}
            </FormGroup>
          </ListItem>
        ))}
      </List>
    </React.Fragment>
  )
}

export default FilterPopover
